// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"d25e6a25","641":"421416a5","653":"a46bd376","683":"58c4f362","788":"7428b81e","895":"f9cbb91c"}[chunkId] + ".css";
};